import { useState, useEffect, React } from "react";
import * as FaIcons from "react-icons/fa";
import { Button, Modal, Container, Row, Col, FormControl, FormLabel } from 'react-bootstrap';
import ClientsList from './ClientsList';
import ClientDataService from './services/client.service';

function SearchClient(props) { 
  const [lgShow, setLgShow] = useState(false);
  const [clientname,setClientname] = useState('');
  const [sorttype, setSorttype] = useState('ASC');
  const [sortfield, setSortfield] = useState('id');
  const [listOfClients, setListOfClients] = useState([]);

  const handleClose = () => setLgShow(false);

  const handleShow = () => {
    setLgShow(true);            
  }

  const onChangeSortType = () => {
    setSorttype(sorttype == 'DESC'?'ASC':'DESC');
    performSearch(clientname,sortfield,sorttype);    
  }

  const onChangeSortField = (e) => {
    setSortfield(e.target.value);
    performSearch(clientname,e.target.value,sorttype);
  }

  const onChangeClientFilterByDescr = (e) => {
    setClientname(e.target.value)
    performSearch(e.target.value,sortfield,sorttype);
  }  

  const performSearch = (descr,sortf,sortt) => {
    ClientDataService.getClientByDescr(descr,sortf,sortt)
      .then(response => {
        console.log(response.data);
        setListOfClients(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  };

  useEffect(() => {performSearch(clientname,sortfield,sorttype)},[]);

    return (
      <>
        <Button className='ms-2' lg={8} style={{maxWidth:"50px",maxHeight:'38px'}} variant="primary" onClick={handleShow}><FaIcons.FaSearch /></Button>      
        <Modal
          size="lg"
          show={lgShow}
          onHide={() => setLgShow(false)}
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              {'Select Client'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Row className='mb-2 d-flex'>
                <Col lg={true}>
                  <FormLabel className='mb-2'>Filter by Client Name:</FormLabel>       
                  <FormControl type="text" name="filterbyclientname" id="filterbyclientname" onChange={onChangeClientFilterByDescr}></FormControl>
                </Col>
                <Col lg={true}>
                  <FormLabel className='mb-2'>Sort By:</FormLabel>       
                    <FormControl as='select' onChange={onChangeSortField}>
                      <option value="id">Client ID</option>
                      <option value="clientname">Client Name</option>
                    </FormControl>
                </Col>
                
                <Col sm={true}>
                  <FormLabel className='mb-2'>Asc/Desc:</FormLabel>       
                  <FormControl style={{maxWidth:"50px"}} as="button" onClick={onChangeSortType}><FaIcons.FaSortAmountDownAlt/></FormControl>
                </Col>          
              </Row>
              <Row>
                <ClientsList handleClose={handleClose} onSelected={props.onSelected} listOfClients = {listOfClients} mode = {1}/>      
              </Row>
            </Container>

          </Modal.Body>
        </Modal>
      </>
    );
  }

  
  export default SearchClient;